import React from 'react';
import UserService from "api/user/user";
import HeaderCustomAction from "v4/features/front/header/components/HeaderCustomAction/HeaderCustomAction";

export default function HeaderCustomActions() {

    return (
        UserService.getCustomActions().map(customAction => (
            <HeaderCustomAction key={customAction.action} customAction={customAction}/>
        ))
    )
}
